import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';

interface PaymentConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPaymentConfirm: (paymentMethod: string) => void;
  totalPrice: number;
}

const PaymentConfirmationModal: React.FC<PaymentConfirmationModalProps> = ({
  isOpen,
  onClose,
  onPaymentConfirm,
  totalPrice
}) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState('qris');

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(price);
  };

  const handlePaymentConfirm = () => {
    onPaymentConfirm(selectedPaymentMethod);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Payment Confirmation</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6">
          {/* Total Bill */}
          <div className="bg-muted p-4 rounded-lg">
            <h3 className="text-lg font-semibold mb-2">Total Bill</h3>
            <p className="text-2xl font-bold text-primary">{formatPrice(totalPrice)}</p>
          </div>

          {/* Payment Methods */}
          {/* <div className="space-y-4">
            <h3 className="text-lg font-semibold">Select Payment Method</h3>
            <RadioGroup
              value={selectedPaymentMethod}
              onValueChange={setSelectedPaymentMethod}
              className="space-y-3"
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="qris" id="qris" />
                <Label htmlFor="qris" className="cursor-pointer">
                  QRIS
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="dana" id="dana" />
                <Label htmlFor="dana" className="cursor-pointer">
                  DANA
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="shopeepay" id="shopeepay" />
                <Label htmlFor="shopeepay" className="cursor-pointer">
                  Shopee Pay
                </Label>
              </div>
            </RadioGroup>
          </div> */}

          {/* Action Buttons */}
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              Cancel
            </Button>
            <Button
              onClick={handlePaymentConfirm}
              className="flex-1"
            >
              Pay Now
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentConfirmationModal;
